export enum ExternalLinks {
    GMAIL = 'https://mail.google.com/',
    YAHOO = 'https://login.yahoo.com/',
    OUTLOOK = 'https://outlook.live.com/',
}
